import { ResidentialOwnersPage } from "@/components/non_registrant/dashboard-residential-owners";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/residential-property-owners")({
  component: ResidentialOwnersPage,
});
